<template>
  <div class="table-wrapper">
    <div v-if="productsTable.length !== 0">
      <div class="wrapper">
        <div class="top-item-wrapper">
          <Card class="card" :isMerchantView="true" :cardData="this.topProduct[0]" />
        </div>
        <div class="notify-wrapper">
          <p class="notify">
            Your most <span class="emphasize">common</span> product.
          </p>
        </div>
      </div>
      <v-data-table :headers="headers" :items="productsTable" :items-per-page="5" hide-default-footer class="elevation-1"></v-data-table>
    </div>
    <div v-else class="no-products">
      <p class="notify">
        Welcome to your <span class="emphasize">products</span> dashboard.<br />
        Here you will see all your <span class="emphasize-1">saved</span>
        <span class="emphasize"> products</span> data.<br />
        <br />
        Shopdrop users will get <span class="emphasize-1">discount</span>
        notifications so they
        <span class="emphasize">return</span> quickly...
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import groupBy from "lodash.groupby";
import Card from "./Card";
export default {
  name: "merchantProducts",
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        { text: "Product Price", value: "price" },
        { text: "Save Count", value: "count" },
        { text: "Total Save Amount", value: "total" },
      ],
    };
  },
  components: {
    Card,
  },

  props: {
    merchantProducts: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters(["products"]),
    productsTable() {
      const items = [];
      const productsByProductId = groupBy(
        this.merchantProducts,
        "shopifyProductId"
      );
      Object.values(productsByProductId).forEach((products) => {
        items.push({
          name: products[0].name,
          price: products[0].price.value,
          count: products.length,
          total: `${products.length * products[0].price.value} ₪`,
        });
      });

      return items;
    },
    topProduct() {
      let max = -Infinity;
      let id = "";
      const x = groupBy(this.merchantProducts, "shopifyProductId");

      Object.entries(x).forEach(([key, value]) => {
        if (value.length > max) {
          console.log(value.length);
          max = value.length;
          id = key;
        }
      });
      console.log(x[id]);
      return x[id];
    },
  },
};
</script>
<style scoped>
.card {
  flex-direction: column;
}
.table-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
}
.table {
  height: 450px;
}
.theme--light.v-data-table {
  border: #dcdcdc40;
}
.odd {
  background-color: whitesmoke;
}
.top-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  margin-right: 0.5%;
  margin-left: 0.5%;
  margin-top: 1%;
  margin-bottom: 1%;
  max-width: 320px;
}
.wrapper {
  width: 100%;
  justify-content: center;
  display: flex;
  margin-bottom: 40px;
}
.emphasize {
  font: 500;
  color: rgb(20, 200, 200);
}
.emphasize-1 {
  font: 500;
  color: #ba22cc;
}
.notify {
  font-family: Helvetica Neue;
  font-size: 30px;
  font-weight: 300;
}
.notify-wrapper {
  display: flex;
  align-items: center;
  padding-left: 35px;
}
</style>
